<template>
  <div>
    <div style="text-align: left">辅料商品SKU:{{this.query.shopProductSku}}</div>
    <WmsTable
      :columns="columnsOperationData"
      :dataSource="datasource"
      @pageChange="pageChangeCall" :isPagination="query" 
    >
    </WmsTable>
  </div>
</template>

<script>
import WmsTable from "@/components/WmsTable";
import { stockOperation } from "@/apis/inventoryDetails";
import { columnsOperationData } from "@/views/inventoryDetails/assist/indexData";
export default {
  name: "dialogTable",
  components: {
    WmsTable,
  },
  data() {
    return {
      columnsOperationData,
      datasource: [],
      query: {
        current: 1,
        pageSize: 10,
        total: 0,
        shopProductSku: "",
      },
    };
  },
  mounted() {},
  methods: {
    pageChangeCall(payload) {
      const { current, pageSize } = payload;
      this.query.current = current;
      this.query.pageSize = pageSize;
      this.detail();
    },
    detail() {
      let params = {
        shopProductSku: this.query.shopProductSku,
        pageNum: this.query.current,
        pageSize: this.query.pageSize,
      };
      stockOperation(params).then(({ code, data }) => {
        if (code === 0) {
          this.datasource = data.records;
          this.query.total = data.total;
        }
      });
    },
  },
};
</script>

<style scoped></style>
